<template>
  <button class="btn btn-primary" @click="openModal">
    <i class="fas fa-plus"></i> Tạo chiến dịch mới
  </button>
  <dialog id="create_campaign" ref="dialogRef" class="modal">
    <div class="modal-box">
      <h3 class="text-lg font-bold">Tạo chiến dịch mới</h3>
      <form @submit="onSubmit">
        <div class="space-y-4 py-4">
          <fieldset class="fieldset">
            <legend class="fieldset-legend">Tên chiến dịch</legend>
            <input
              v-model="campaignName"
              type="text"
              class="input input-bordered w-full"
              :class="{ 'input-error': errors.campaignName }"
              placeholder="Nhập chiến dịch"
            />
            <p v-if="errors.campaignName" class="label text-error">
              {{ errors.campaignName }}
            </p>
          </fieldset>

          <fieldset class="fieldset">
            <legend class="fieldset-legend">Mô tả chiến dịch</legend>
            <textarea
              v-model="description"
              class="textarea textarea-bordered w-full"
              :class="{ 'textarea-error': errors.description }"
              placeholder="Mô tả chiến dịch của bạn"
            ></textarea>
            <p v-if="errors.description" class="label text-error">
              {{ errors.description }}
            </p>
          </fieldset>
        </div>
        <div class="modal-action">
          <button type="button" class="btn" @click="closeModal">Đóng</button>
          <button
            type="submit"
            class="btn btn-primary ml-2"
            :disabled="isCreating"
          >
            Tạo chiến dịch
          </button>
        </div>
      </form>
    </div>
  </dialog>
</template>
<script setup lang="ts">
import { createCampaign } from "@/api/campaign";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { useForm } from "vee-validate";
import { ref } from "vue";
import { toast } from "vue3-toastify";

const { defineField, handleSubmit, errors, resetForm } = useForm({
  validationSchema: {
    campaignName: "required|maxLength:500",
    description: "maxLength:1000",
  },
});

const [campaignName] = defineField("campaignName");
const [description] = defineField("description");

const queryClient = useQueryClient();

const { mutate: doCreateCampaign, isPending: isCreating } = useMutation({
  mutationFn: async (data: { campaignName: string; description?: string }) => {
    return await createCampaign({
      name: data.campaignName,
      description: data.description ?? "",
    });
  },
  onSuccess: () => {
    toast.success("Tạo chiến dịch thành công!");
    queryClient.invalidateQueries({ queryKey: ["campaigns"] });
    closeModal();
  },
  onError: (err) => {
    console.error(err);
    toast.error("Đã xảy ra lỗi khi tạo chiến dịch.");
  },
});

const onSubmit = handleSubmit((values) => {
  doCreateCampaign({
    campaignName: values.campaignName,
    description: values.description,
  });
});

const dialogRef = ref<HTMLDialogElement | null>(null);

const openModal = () => {
  resetForm();
  dialogRef.value?.showModal();
};

const closeModal = () => {
  dialogRef.value?.close();
  resetForm();
};
</script>
